import * as AuthActions from './auth.actions';
import { AusmitError } from "../../shared/interfaces";
import { CriteriaModel, EmptyCriteria } from "../../shared/interfaces/CriteriaModel";
import { PaginatorModel } from "../../shared/interfaces/PaginatorModel";

/*Defining the state shape*/
export interface AuthState {
	error: AusmitError | null;
	hasError: boolean;
	requestProcessing: boolean;
	CustomerDoRegister: {
		success: boolean;
		response: any;
		error: AusmitError | null;
		hasError: boolean;
	};
	forgotPassword: {
		error: AusmitError | null;
		hasError: boolean;
		success: boolean
	};
	resetPassword: {
		error: AusmitError | null;
		hasError: boolean;
	};
	WishlistItems: {
		criteria: CriteriaModel;
		response: PaginatorModel | null;
	};
	ShippingAddress: {
		response: any;
	};
	AddItemToWishlist: {
		response: any
	}
	DeleteItemToWishlist: {
		response: any
	}
	ResendOtp: {
		response: any
	}
	GetCityAndStateFromZipcode: {
		response: any
	}
}

/*Setting the initial state*/
export const authInitialState: AuthState = {
	error: null,
	hasError: false,
	requestProcessing: false,
	CustomerDoRegister: {
		success: false,
		response: null,
		error: null,
		hasError: false,
	},
	forgotPassword: {
		error: null,
		hasError: false,
		success: false,
	},
	resetPassword: {
		error: null,
		hasError: false,
	},
	WishlistItems: {
		criteria: EmptyCriteria,
		response: null,
	},
	ShippingAddress: {
		response: null
	},
	AddItemToWishlist: {
		response: null
	},
	DeleteItemToWishlist: {
		response: null
	},
	ResendOtp: {
		response: null
	},
	GetCityAndStateFromZipcode: {
		response: null
	}
};

/*Creating the reducer function*/
export function AuthReducer(
	state = authInitialState,
	action: AuthActions.Actions
): AuthState {
	switch (action.type) {
		case AuthActions.ActionTypes.SetRequestProcessing: {
			return {
				...state,
				requestProcessing: action.payload.requestProcessing,
			};
		}

		case AuthActions.ActionTypes.CUSTMER_DO_LOGIN: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case AuthActions.ActionTypes.CUSTOMER_DO_LOGIN_SUCCESS: {
			return {
				...state,
				error: null,
				hasError: false,
				requestProcessing: false,
			};
		}
		case AuthActions.ActionTypes.CUSTOMER_DO_LOGIN_ERROR: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				requestProcessing: false,
			};
		}

		case AuthActions.ActionTypes.CUSTOMER_DO_REGISTER: {
			return {
				...state,
				requestProcessing: true,
				CustomerDoRegister: {
					...state.CustomerDoRegister
				}
			};
		}

		case AuthActions.ActionTypes.CUSTOMER_DO_REGISTER_SUCCESS: {
			return {
				...state,
				requestProcessing: false,
				error: null,
				hasError: false,
				CustomerDoRegister: {
					...state.CustomerDoRegister,
					success: true,
					response: action.payload,
					error: null,
					hasError: false,
				}
			};
		}

		case AuthActions.ActionTypes.CUSTOMER_DO_REGISTER_ERROR: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true,
				CustomerDoRegister: {
					...state.CustomerDoRegister,
					success: false,
					response: null,
					error: action.payload,
					hasError: true,
				}
			};
		}

		case AuthActions.ActionTypes.ForgotPassword: {
			return {
				...state,
				requestProcessing: true,
				forgotPassword: {
					error: null,
					hasError: false,
					success: false,
				}
			};
		}

		case AuthActions.ActionTypes.ForgotPasswordSuccess: {
			return {
				...state,
				requestProcessing: false,
				forgotPassword: {
					error: null,
					hasError: false,
					success: true,
				}
			};
		}

		case AuthActions.ActionTypes.ForgotPasswordError: {
			return {
				...state,
				requestProcessing: false,
				forgotPassword: {
					error: action.payload,
					hasError: true,
					success: false,
				}
			};
		}

		case AuthActions.ActionTypes.ResetPassword: {
			return {
				...state,
				requestProcessing: true,
				resetPassword: {
					error: null,
					hasError: false,
				}
			};
		}

		case AuthActions.ActionTypes.ResetPasswordSuccess: {
			return {
				...state,
				requestProcessing: false,
				resetPassword: {
					error: null,
					hasError: false,
				}
			};
		}

		case AuthActions.ActionTypes.ResetPasswordError: {
			return {
				...state,
				requestProcessing: false,
				resetPassword: {
					error: action.payload,
					hasError: true,
				}
			};
		}

		case AuthActions.ActionTypes.UpdateProfile: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case AuthActions.ActionTypes.UpdateProfileSuccess: {
			return {
				...state,
				requestProcessing: false,
			};
		}
		case AuthActions.ActionTypes.UpdateProfileError: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true
			};
		}

		case AuthActions.ActionTypes.DeleteAcount: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case AuthActions.ActionTypes.DeleteAcountSuccess: {
			return {
				...state,
				requestProcessing: false,
			};
		}
		case AuthActions.ActionTypes.DeleteAcountError: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true
			};
		}

		case AuthActions.ActionTypes.WishlistItems: {
			return {
				...state,
				requestProcessing: true,
				WishlistItems: {
					...state.WishlistItems,
					criteria: action.payload
				}
			};
		}
		case AuthActions.ActionTypes.WishlistItemsSuccess: {
			return {
				...state,
				requestProcessing: false,
				WishlistItems: {
					...state.WishlistItems,
					response: action.payload
				}
			};
		}
		case AuthActions.ActionTypes.WishlistItemsError: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true,
				WishlistItems: {
					...state.WishlistItems,
					response: null
				}
			};
		}
		case AuthActions.ActionTypes.WishlistItemsReset: {
			return {
				...state,
				requestProcessing: false,
				WishlistItems: {
					...state.WishlistItems,
					criteria: EmptyCriteria,
					response: null,
				}
			};
		}
		case AuthActions.ActionTypes.GetShippingAddress: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case AuthActions.ActionTypes.GetShippingAddressSuccess: {
			return {
				...state,
				requestProcessing: false,
				ShippingAddress: {
					response: action.payload
				}
			};
		}
		case AuthActions.ActionTypes.GetShippingAddressError: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true
			};
		}

		case AuthActions.ActionTypes.CreateVisitor: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case AuthActions.ActionTypes.CreateVisitorSuccess: {
			return {
				...state,
				requestProcessing: false,
			};
		}
		case AuthActions.ActionTypes.CreateVisitorError: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true
			};
		}

		case AuthActions.ActionTypes.AddItemToWishlist: {
			return {
				...state,
				requestProcessing: true,
			};
		}

		case AuthActions.ActionTypes.AddItemToWishlistSuccess: {
			return {
				...state,
				requestProcessing: false,
				AddItemToWishlist: {
					response: action.payload
				}
			};
		}

		case AuthActions.ActionTypes.AddItemToWishlistError: {
			return {
				...state,
				requestProcessing: false,
			};
		}

		case AuthActions.ActionTypes.DeleteItemToWishlist: {
			return {
				...state,
				requestProcessing: true,
			};
		}

		case AuthActions.ActionTypes.DeleteItemToWishlistSuccess: {
			return {
				...state,
				requestProcessing: false,
				DeleteItemToWishlist: {
					response: action.payload
				}
			};
		}

		case AuthActions.ActionTypes.DeleteItemToWishlistError: {
			return {
				...state,
				requestProcessing: false,
			};
		}

		case AuthActions.ActionTypes.CUSTOMER_DO_LOGOUT: {
			return {
				...state,
				requestProcessing: true,
			};
		}
		case AuthActions.ActionTypes.CUSTOMER_DO_LOGOUT_SUCCESS: {
			return {
				...state,
				requestProcessing: false,
			};
		}
		case AuthActions.ActionTypes.CUSTOMER_DO_LOGOUT_ERROR: {
			return {
				...state,
				requestProcessing: false,
				error: action.payload,
				hasError: true
			};
		}

		case AuthActions.ActionTypes.ResendOtp: {
			return {
				...state,
				requestProcessing: true,
			};
		}

		case AuthActions.ActionTypes.ResendOtpSuccess: {
			return {
				...state,
				requestProcessing: false,
				ResendOtp: {
					response: action.payload
				}
			};
		}

		case AuthActions.ActionTypes.ResendOtpError: {
			return {
				...state,
				requestProcessing: false,
			};
		}

		case AuthActions.ActionTypes.GetCityAndStateFromZipcode: {
			return {
				...state,
				requestProcessing: true,
				GetCityAndStateFromZipcode: {
					response: null
				}
			};
		}

		case AuthActions.ActionTypes.GetCityAndStateFromZipcodeSuccess: {
			return {
				...state,
				requestProcessing: false,
				GetCityAndStateFromZipcode: {
					response: action.payload
				}
			};
		}

		case AuthActions.ActionTypes.GetCityAndStateFromZipcodeError: {
			return {
				...state,
				requestProcessing: false,
				GetCityAndStateFromZipcode: {
					response: null
				}
			};
		}

		default:
			return state;
	}
}
